import { LinkComponent } from 'app/area/links-section/link';
import { LinksGroup } from 'app/area/links-section/types-store';
import { isObjectEmpty } from 'app/infrastructure/data/object';
import * as React from 'react';
import styles from './links-groups.scss';

interface LinksGroupProps {
  size?: string;
  linksGroup: LinksGroup;
}

export function LinksGroupComponent({ size, linksGroup }: LinksGroupProps) {

  if (!linksGroup || isObjectEmpty(linksGroup)) {
    return null;
  }

  return (
    <div className={`${!!size ? size : 'col-md-6'} ${styles.linksGroup}`}>
      <div>
        <h1 className={styles.description}>{linksGroup.description}</h1>
        <div className={styles.description}>
          {linksGroup.longDescription}
        </div>
      </div>
      <div>
        {linksGroup.links?.map((link, index) => <LinkComponent key={index} link={link} />)}
      </div>
    </div>);
}
